<template>
  <div class="containers">
    <div class="maskName" v-if="lonLatShow">
      <div
        class="name"
        v-if="searchType != '1' && searchType != '2'"
        style="color: #515150"
      >
        {{ name }}
      </div>
      <div style="margin: 0 10px; color: #515150">
        <div class="lonLat">{{ $t("public.lon") }}：{{ lon }}</div>
        <div class="lonLat">{{ $t("public.lat") }}：{{ lat }}</div>
      </div>
    </div>
    <!-- 头部搜索 -->
    <div class="top">
      <div style="position: relative">
        <el-input
          size="mini"
          v-model="searchKey"
          :placeholder="placeholder"
          @keyup.enter.native="toSearch"
        ></el-input>
        <div
          v-if="searchType == '2'"
          style="position: absolute; top: 30px; left: 10px; font-size: 12px"
        >
          {{ this.$t("public.ps") }}
        </div>
      </div>
      <div>
        <el-select
          v-model="searchType"
          size="mini"
          @change="handleChange"
          style="margin: 0 10px"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div>
        <el-button @click="toSearch" type="primary" size="mini">{{
          $t("public.search")
        }}</el-button>
      </div>
      <div
        style="margin: 0 10px 0 30px"
        v-if="searchType != '1' && searchType != '2'"
        v-authority="'1-2'"
      >
        <el-input
          :placeholder="$t('public.p0')"
          size="mini"
          v-model="radius"
          @blur="handleRadius"
        ></el-input>
      </div>
      <div
        v-authority="'1-2'"
        style="margin: 0 10px"
        v-if="searchType != '1' && searchType != '2'"
      >
        <el-button size="mini" @click="showRadius" type="danger">{{
          $t("public.display")
        }}</el-button>
      </div>
      <div style="margin-left: 10px">
        <el-checkbox v-model="checked" @change="radiusChange">{{
          $t("public.radiusShow")
        }}</el-checkbox>
        <el-checkbox v-model="userCheck" @change="usersChange">{{
          $t("public.usersShow")
        }}</el-checkbox>
      </div>
    </div>
    <div class="circle"></div>
    <!-- 基础地图组件 -->
    <Map ref="map" @load="handlerMapLoad" @toMeasure="toMeasure"></Map>
  </div>
</template>
  
  <script>
import {
  getStations,
  getJson,
  updateStationRadius,
  getUsers,
} from "@/api/index";
import Measure from "./component/measure";
import Vue from "vue";
import mapboxgl from "mapbox-gl";
import Map from "./component/map.vue";
import "mapbox-gl/dist/mapbox-gl.css"; // 引入控件样式
// import online from "@/assets/images/public/online.png"; // 在线
import userStation from "@/assets/images/public/userStation.png"; // 离线
import online from "@/assets/images/public/online.png"; // 离线
import warning from "@/assets/images/public/warning.png"; // 离线
import offline from "@/assets/images/public/offline.png"; // 离线
import MapPopup from "./component/mapPopup.vue"; // 地图弹窗
// import { Baidu_GPS } from "../../utils/coord"; // 百度转GPS经纬度
import { circle, feature } from "@turf/turf";
export default {
  name: "positionMap",
  components: {
    Map,
    // MapPopup
  },
  data() {
    return {
      lonLatShow: false,
      radius: "",
      options: [
        {
          value: "0",
          label: this.$t("public.stationName"),
        },
        {
          value: "1",
          label: this.$t("public.local"),
        },
        {
          value: "2",
          label: this.$t("public.lonlat"),
        },
      ],
      searchKey: "",
      searchType: "0",
      name: "",
      lon: 0,
      lat: 0,
      timer: null,
      loading: false,
      popup: null,
      points: [], // 坐标点
      wbs: null,
      placeholder: this.$t("public.p5"),
      checked: true,
      userCheck: true,
      measureTools: null,
      userList: [],
      userLine: [],
      layerType: "",
    };
  },
  watch: {
    points: {
      handler(newV) {
        if (newV && newV.length) {
          // this.addMapPoints();
        }
      },
      deep: true,
    },
  },
  mounted() {},
  activated() {
    if (this.map) {
      this.map.resize();
    }
    // this.remoteMethod();
  },
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  // beforeDestroy(){
  //   if (this.timer) {
  //     clearInterval(this.timer);
  //     this.timer = null;
  //   }
  // },
  methods: {
    getUserList() {
      let bs = [];
      // console.log(this.points, "pppooo");
      getUsers().then((res) => {
        // 在线ntrip列表
        this.userList = res.data.map((item, index) => {
          this.points.map((f) => {
            if (f.properties.name == item.bn) {
              this.userLine.push({
                type: "Feature",
                properties: {},
                geometry: {
                  type: "LineString",
                  coordinates: [
                    [item.lo, item.la],
                    [f.properties.lon, f.properties.lat],
                  ],
                },
              });
            }
          });
          return {
            type: "Feature",
            properties: {
              // id: 1,
              status: item.st,
              name: item.us,
              lon: item.lo,
              lat: item.la,
              stationName: item.bn, // 当前基站
              // radius: item.rs
            },
            geometry: {
              type: "Point",
              coordinates: [item.lo, item.la],
            },
          };
        });
        // console.log(this.userList, "this.userList")
        this.addMapUserPoints();
      });
    },
    // 获取基站
    getList() {
      let param = {
        stationName: this.searchKey,
      };
      getStations(param).then((res) => {
        // console.log(res, "resss")
        this.points = res.data.map((item, index) => {
          return {
            type: "Feature",
            id: index,
            properties: {
              // id: 1,
              status: item.st,
              name: item.nm,
              lon: item.lo,
              lat: item.la,
              radius: item.rs,
            },
            geometry: {
              type: "Point",
              coordinates: [item.lo, item.la],
            },
          };
        });
        this.addMapPoints();
        this.drawCircle();
        this.getUserList();
      });
    },
    toMeasure() {
      this.measureTools.distance();
    },
    handleRadius() {
      this.radius = Number(this.radius).toFixed(2);
    },
    // 展示自定义半径圆
    showRadius() {
      if (this.layerType == "userPoint") {
        this.$message.warning(this.$t("public.noSet"));
        return;
      }
      if (this.radius < 0 || this.radius > 200) {
        this.$message.warning(this.$t("public.ver9"));
        return;
      }
      if (this.radius && this.name) {
        this.points.forEach((item, index) => {
          if (this.name == item.properties.name) {
            item.properties.radius = Number(this.radius);
          }
        });
        this.drawCircle();
        let param = {
          sta: this.name,
          radius: Number(this.radius),
        };
        updateStationRadius(param).then((res) => {
          if (res.code == 200) {
            this.$message.success(this.$t("public.success1"));
          }
        });
      } else {
        this.$message.warning(this.$t("public.ver12"));
      }
    },
    toSearch() {
      let that = this;
      let point = [];
      let propsData = {};
      let name = "";
      let circleID = "";
      if (!this.searchKey) {
        this.$message.warning(this.$t("public.p5"));
        return;
      }
      if (this.searchType == "0") {
        that.name = ""
        this.lonLatShow = false;
        this.points.forEach((item, index) => {
          if (this.searchKey == item.properties.name) {
            // console.log(item, "item");
            point = item.geometry.coordinates;
            propsData = {
              data: item.properties,
            };
            that.name = item.properties.name;
            this.lon = item.properties.lon;
            this.lat = item.properties.lat;
            // circleID = index
            // item.properties.radius = 500 // 修改数据
            // this.showRadius()
            // console.log(this.map.getSource('circle'), "this.map.getSource('circle')")
            // this.map.getSource('circle').updateData(item)
          }
        });
        if (that.name) {
          this.lonLatShow = true;
          this.map.flyTo({
            center: point,
            zoom: 9,
            duration: 1000,
            essential: true,
          });
          this.createPopup(point, {data:{name: that.name}})
        } else {
          this.$message.warning(this.$t("public.noStation"));
        }
      } else if (this.searchType == "1") {
        // 地名搜索
        let param = {
          name: this.searchKey,
        };
        getJson(param).then((res) => {
          point = res.features[0].geometry.coordinates;
          this.map.getSource("location").setData({
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: res.features[0].geometry.coordinates,
                },
              },
            ],
          });
          this.lon = point[0];
          this.lat = point[1];
          this.map.flyTo({
            center: point,
            zoom: 9,
            duration: 1000,
            essential: true,
          });
        });
      } else {
        // 经纬度搜素
        this.points.forEach((item) => {
          let lonlat = this.searchKey.split(",");
          point = lonlat;
          if (
            lonlat[0] == item.geometry.coordinates[0] &&
            lonlat[1] == item.geometry.coordinates[1]
          ) {
            point = item.geometry.coordinates;
            propsData = {
              data: item.properties,
            };
            that.name = item.properties.name;
            this.lon = item.properties.lon;
            this.lat = item.properties.lat;
          }
        });
        this.map.getSource("location").setData({
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: point,
              },
            },
          ],
        });
        this.map.flyTo({
          center: point,
          zoom: 9,
          duration: 1000,
          essential: true,
        });
      }
    },
    radiusChange(e) {
      // 切换半径显示开关
      if (e) {
        this.map.setLayoutProperty("circleFill", "visibility", "visible");
        this.map.setLayoutProperty("circleLine", "visibility", "visible");
      } else {
        this.map.setLayoutProperty("circleFill", "visibility", "none");
        this.map.setLayoutProperty("circleLine", "visibility", "none");
      }
      // console.log("切换");
    },
    usersChange(e){
      if (e) {
        this.map.setLayoutProperty("userline", "visibility", "visible");
        this.map.setLayoutProperty("userPoint", "visibility", "visible");
      } else {
        this.map.setLayoutProperty("userline", "visibility", "none");
        this.map.setLayoutProperty("userPoint", "visibility", "none");
      }
    },
    handleChange(e) {
      this.name = "";
      this.lon = 0;
      this.lat = 0;
      switch (e) {
        case "0":
          // this.placeholder = "请输入基站名称";
          this.placeholder = this.$t("public.p5");
          break;
        case "1":
          // this.placeholder = "请输入地址";
          this.placeholder = this.$t("public.p6");
          break;
        default:
          // this.placeholder = "请输入经纬度坐标";
          this.placeholder = this.$t("public.p7");
          break;
      }
    },
    // 画圆圈
    // center = [], radius = 0
    drawCircle() {
      // console.log(this.points, "this.points");
      let options = {
        steps: 64, //分割数量 数量越多圆越精细 默认值：64（如果圆比较大推荐类似 Math.floor(radius) * 10 这样根据半径可变的切割）
        units: "kilometers", //单位  可选值：degrees, radians, miles, kilometers
      };
      let allCircle = this.points.map((item) => {
        return circle(
          item.geometry.coordinates,
          item.properties.radius,
          options
        );
      });
      let features = allCircle.map((item, index) => {
        return {
          type: "Feature",
          id: index,
          properties: {},
          geometry: {
            type: "Polygon",
            coordinates: [...item.geometry.coordinates],
          },
        };
      });
      let d = {
        type: "FeatureCollection",
        features: features,
      };
      this.map.getSource("circle").setData(d);
    },
    loadImages() {
      this.map.loadImage(userStation, (error, image) => {
        // 用户
        if (error) throw error;
        this.map.addImage("userStation", image);
      });
      this.map.loadImage(online, (error, image) => {
        // 在线
        if (error) throw error;
        this.map.addImage("online", image);
      });
      this.map.loadImage(warning, (error, image) => {
        // 故障
        if (error) throw error;
        this.map.addImage("warning", image);
      });
      this.map.loadImage(offline, (error, image) => {
        // 离线
        if (error) throw error;
        this.map.addImage("offline", image);
      });
    },
    initMeasureTool() {
      this.measureTools = new Measure(this.map, this.measureComplete);
    },
    measureComplete(e) {
      this.$emit("measure", e);
    },
    handlerMapLoad(map) {
      this.map = map;
      this.setDefaultLayer();
      this.loadImages();
      this.initMeasureTool();
      this.getList();
    },
    // 设置默认图层
    async setDefaultLayer() {
      // 基站圆圈数据源
      this.map.addSource("circle", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          // features: this.drawCircle()
          features: [],
        },
      });
      // 用户头像数据源
      this.map.addSource("userSource", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          // features: this.drawCircle()
          features: [],
        },
      });
      // 用户和基站连线
      this.map.addSource("lines", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });
      // 连线
      this.map.addLayer({
        id: "userline",
        type: "line",
        source: "lines",
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
        paint: {
          "line-color": "#0b57d0",
          "line-width": 2,
        },
      });
      // 用户头像点
      this.map.addLayer({
        id: "userPoint",
        type: "symbol",
        source: "userSource", // reference the data source
        filter: ["!=", "id", ""],
        layout: {
          "icon-allow-overlap": true, // 是否允许覆盖
          "icon-image": [
            "case",
            ["all", ["==", ["get", "status"], 1]],
            "online",
            "userStation",
          ], // reference the image
          "icon-size": 0.3,
          visibility: "visible",
          // "icon-anchor": "center",
        },
      });
      // 跳转定位红点
      this.map.addSource("location", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [
            //   {
            //   type: "Feature",
            //   geometry: {
            //     type: "Point",
            //     coordinates: [12.1,12.1],
            //   },
            // }
          ],
        },
      });
      // 定位红点图层
      this.map.addLayer({
        id: "flyPoint",
        type: "circle",
        source: "location", // reference the data source
        // filter: ["!=", "id", ""],
        paint: {
          "circle-color": "#e63f31",
          "circle-radius": 10,
          "circle-stroke-width": 1,
          "circle-stroke-color": "#fff",
        },
      });
      // 基站圆圈填充颜色
      this.map.addLayer({
        id: "circleFill",
        type: "fill",
        source: "circle",
        filter: ["!=", "id", ""],
        paint: {
          "fill-color": "#d0f262",
          "fill-opacity": 0.6,
          "fill-outline-color": "#000",
          // 'fill-opacity-transition': { duration: 500 }
          // "fill-emissive-strength": 0
        },
      });
      this.map.addLayer({
        id: "circleLine",
        type: "line",
        source: "circle",
        filter: ["!=", "id", ""],
        paint: {
          "line-color": "#000",
          "line-width": 1,
        },
      });
      // 平铺点数据源
      this.map.addSource("receiver", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
        // cluster: false,
        // clusterMaxZoom: 12,
        // clusterRadius: 50,
      });
      // 基站平铺点
      this.map.addLayer({
        id: "receiverPoint",
        type: "symbol",
        source: "receiver", // reference the data source
        filter: ["!=", "id", ""],
        layout: {
          "icon-allow-overlap": true, // 是否允许覆盖
          "icon-image": [
            "case",
            ["all", ["==", ["get", "status"], 2]],
            "online",
            ["all", ["==", ["get", "status"], 1]],
            "warning",
            ["all", ["==", ["get", "status"], 0]],
            "offline",
            "offline",
          ],
          "icon-size": 0.3,
          "icon-offset": [0, -25],
          visibility: "visible",
        },
      });
      this.map.on("mousemove", this.handlerMapHover);
      this.map.on("click", this.handlerMapClick);
      this.handlerUnit();
      this.map.on("move", () => {
        this.handlerUnit();
      });
      // this.map.getSource("receiver").setData(this.points);
    },
    // 设置比例尺单位
    handlerUnit() {
      if (document.getElementsByClassName("mapboxgl-ctrl-scale").length) {
        let t = document.getElementsByClassName("mapboxgl-ctrl-scale")[0]
          .innerHTML;
        if (t.indexOf("米") != -1) {
          document.getElementsByClassName("mapboxgl-ctrl-scale")[0].innerHTML =
            t.slice(0, t.length - 2) + "m";
        } else {
          document.getElementsByClassName("mapboxgl-ctrl-scale")[0].innerHTML =
            t.slice(0, t.length - 2) + "km";
        }
      }
    },
    // 添加地图点
    addMapPoints() {
      this.map.getSource("receiver").setData({
        type: "FeatureCollection",
        features: this.points,
      });
    },
    // 添加用户地图点
    addMapUserPoints() {
      // 添加用户点
      this.map.getSource("userSource").setData({
        type: "FeatureCollection",
        features: this.userList,
      });
      // 添加用户与基站的连线
      this.map.getSource("lines").setData({
        type: "FeatureCollection",
        features: this.userLine,
      });
    },
    // 处理地图鼠标悬浮事件
    handlerMapHover(e) {
      const features = this.map.queryRenderedFeatures(e.point, {
        // , "circleFill"
        layers: ["receiverPoint", "userPoint"],
      });
      if (features.length) {
        let hasLine = features.find(
          (f) => f.layer.id == "trackLine" || f.layer.id == "realTrackLine"
        );
        this.map.getCanvas().style.cursor = "pointer";
      } else {
        // this.highLigth(true);
        this.map.getCanvas().style.cursor = "";
      }
    },
    // 处理地图点击事件
    handlerMapClick(e) {
      const features = this.map.queryRenderedFeatures(e.point, {
        // , "circleFill"
        layers: ["receiverPoint", "userPoint"],
      });
      if (features.length) {
        if (this.popup) {
          this.popup.remove();
          this.popup = null;
          // this.lonLatShow = false
        }
        if (
          features[0].layer.id == "receiverPoint" ||
          features[0].layer.id == "userPoint"
          // && features[0].properties.id
        ) {
          this.lonLatShow = true;
          this.layerType = features[0].layer.id;
          // console.log(features[0].properties, "features[0].properties");
          this.name = features[0].properties.name;
          this.lon = features[0].properties.lon;
          this.lat = features[0].properties.lat;
          let propsData = {
            // 弹窗需要的数据
            data: features[0].properties,
            // lang: this.$t("label.positionMap"),
          };
          this.createPopup(features[0].geometry.coordinates, propsData);
        }
      } else {
        // this.map.setFilter("highLight", ["in", "id", ""]); // 点击显示包含此id的图标
        // this.map.setFilter("receiverPoint", ["!=", "id", ""]); // 点击后只显示不包含该id的图标
        this.clearPopup(); // 清除弹框
      }
    },
    createPopup(point = [], propsData = {}) {
      // if(this.popup){
      //   this.popup.remove();
      // }
      this.clearPopup();
      // console.log(propsData, "ppp");
      const p = Vue.extend(MapPopup);
      let vm = new p({
        propsData: propsData,
      });
      vm.$mount(); //挂载
      this.popup = new mapboxgl.Popup()
        .setLngLat(point)
        .setMaxWidth("200") //设置弹窗最大宽度
        .setDOMContent(vm.$el) //插入节点
        .setOffset({ bottom: [0, -10] })
        .addTo(this.map);
      this.popup.on("close", () => {
        // this.map.setFilter("highLight", ["in", "id", ""]); // 点击显示包含此id的图标
        // this.map.setFilter("receiverPoint", ["!=", "id", ""]); // 点击后只显示不包含该id的图标
      });
    },
    clearPopup() {
      if (this.popup) {
        this.popup.remove();
        this.popup = null;
      }
    },
    // 跳转到定位点
    toFly(point) {
      // console.log(point, "pppp");
      this.map.flyTo({
        center: point,
        zoom: 9,
        duration: 500,
        essential: true,
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.containers {
  height: calc(100% - 60px);
  width: 100%;
  position: relative;
  .maskName {
    position: absolute;
    top: 60px;
    z-index: 99;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 10px;
  }
  .top {
    display: flex;
    align-items: center;
    padding: 15px;
    // margin-top: 10px;
    margin-left: 10px;
    // font-size: 14px;
    .name {
      // min-width: 100px;
    }
    .lonLat {
      // min-width: 100px;
    }
  }
  .radius {
    display: flex;
    align-items: center;
  }
  .circle {
    display: flex;
    align-items: center;
    padding: 0 5px 5px 5px;
  }
}
.el-button {
  border: none;
}
.el-button--primary {
  background-color: #659b5d;
}
.mgl20 {
  margin-left: 20px;
}
::v-deep {
  a.mapboxgl-ctrl-logo {
    display: none;
  }
}
::v-deep {
  .mapboxgl-popup-close-button {
    font-size: 24px;
    right: 4px;
    top: 4px;
  }
}
</style>